import { useNavigate } from 'react-router-dom'
import { ArrowForwardIcon } from '~/@mid_ui/icons/ArrowForwardIcon'
import { GraphIcon } from '~/@mid_ui/icons/GraphIcon'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { Button } from '~/shadcn/ui/button/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '~/shadcn/ui/dialog'

type Props = { onClose(): void }

function IdentityVerificationDialog({ onClose }: Props) {
  const navigate = useNavigate()
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogTitle
          title="Bez overenia vašej identity žiaľ, nie je možné investovať."
          aria-description="Bez overenia vašej identity žiaľ, nie je možné investovať."
        />
        <DialogDescription
          title="Po overení môžete investovať. Biometrické overenie je bezpečné a veľmi efektívne."
          aria-description="Bez overenia vašej identity žiaľ, nie je možné investovať."
        />
        <div className="flex flex-col gap-12 py-8 md:p-8">
          <HeadingTwo className="">
            Bez overenia vašej identity žiaľ, nie je možné investovať.
          </HeadingTwo>
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <GraphIcon />
              <p className="font-medium">Po overení môžete investovať</p>
            </div>
            <div className="flex flex-row items-center gap-2">
              <GraphIcon />
              <p className="font-medium">
                Biometrické overenie je bezpečné a veľmi efektívne.
              </p>
            </div>
          </div>
          <div className="flex flex-col w-full md:flex-row gap-4 items-center">
            <Button
              variant="outline"
              className="w-full md:w-auto"
              onClick={() => navigate('/projects')}>
              Odložiť na neskôr
            </Button>
            <Button
              variant="accent"
              className="w-full md:w-auto md:flex-grow"
              size="3xl"
              onClick={onClose}>
              <span>Overiť identitu teraz</span>
              <ArrowForwardIcon className="ml-2" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { IdentityVerificationDialog }
